const styles = theme => ({
    grow: {
        flexGrow: 1,
    },
    labelIcon: {
        color: theme.palette.info.main,
    },
    labelText: {
        fontSize: "0.9rem",
        fontWeight: 500,
    },
    cardHeaderAvatar: {
        color: theme.palette.getContrastText(theme.palette.primary.main),
        backgroundColor: theme.palette.primary.light,
        fontSize: "0.9rem",
        fontWeight: 600,
        height: "25px",
        paddingLeft: "3px",
        paddingRight: "3px",
        marginLeft: "0px",
        marginRight: "5px",
    },
    cardHeader: {
        cursor: "pointer",
        paddingLeft: "0px",
        paddingRight: "0px",
        paddingTop: "0px",
        paddingBottom: "0px",
    },
    ownerText: {
        fontSize: "0.85rem",
        color: theme.palette.text.secondary,
        marginLeft: theme.spacing(1),
        marginBottom: theme.spacing(1)
    },
    cardSubHeader: {
        cursor: "pointer",
        paddingLeft: "3px",
        paddingRight: "3px",
        paddingTop: "0px",
        paddingBottom: "5px",
    },
    cardSubHeaderIcon: {
        lineHeight: "inherit",
    },
    cardSubHeaderText: {
        fontSize: "0.8rem",
        display: "table-cell",
        verticalAlign: "middle",
    },
    cardMedia: {
        cursor: "pointer",
    },
    badge: {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.subtle,
        display: "table",
        paddingLeft: "5px",
        paddingRight: "5px",
        paddingTop: "3px",
        paddingBottom: "3px",
        fontSize: "0.8rem",
        fontWeight: 550,
        marginRight: "5px"
    },
    likeIcon: {
        color: theme.palette.text.secondary,
        fontSize: "1rem",
    },
    likeText: {
        color: theme.palette.text.secondary,
        fontSize: "0.9rem",
        paddingLeft: "3px",
        paddingRight: "5px",
    },
    downloadIcon: {
        color: theme.palette.text.secondary,
        fontSize: "1rem",
    },
    downloadText: {
        paddingLeft: "3px",
        color: theme.palette.text.secondary,
        fontSize: "0.9rem",
    },
    mediaSwitch: {
        paddingTop: theme.spacing(1),
        display: 'inline-flex',
        alignItems: 'center'
    },
    mediaSwitchIcon: {
        marginLeft: theme.spacing(0.5),
        marginRight: theme.spacing(0.5),
        fontSize: "1.1rem",
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(0.5),
        color: theme.palette.text.secondary,
        transition: theme.transitions.create(['background-color', 'color'], {
            duration: theme.transitions.duration.short
        })
    },
    mediaSwitchIconActive: {
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.action.selected
    },
    mediaSwitchText: {
        marginLeft: theme.spacing(0.5),
        marginRight: theme.spacing(0.5),
        fontSize: "0.85rem",
        fontWeight: 600,
        color: theme.palette.text.secondary,
        transition: theme.transitions.create(['color'], {
            duration: theme.transitions.duration.short
        })
    },
    mediaSwitchTextActive: {
        color: theme.palette.text.primary
    },
    statusIcon: {
        fontSize: "1.1rem",
        marginLeft: theme.spacing(0.6),
        marginTop: theme.spacing(0.6),
        marginRight: theme.spacing(0.5)
    },
    statusPublished: {
        color: theme.palette.success.main
    },
    statusSubmitted: {
        color: theme.palette.warning.main
    },
    statusRejected: {
        color: theme.palette.error.main
    },
    statusDraft: {
        color: theme.palette.info.main
    }
});

export default styles;
